export default __webpack_public_path__ + "static/media/NIE_touchpoint_04.8c96e968.mp4";